// What the pane says when the server fails (GID-83 review). The API layer
// already turns a 5xx into a full sentence (ERROR_MESSAGES.server), and the
// pane wrapped it again: "Server error: Server error occurred. Please try
// again later.. Please try again later."

import { ERROR_MESSAGES } from "../config/api.js";

/** One sentence for a server error: the server's own detail when it sent one. */
export function serverErrorMessage(error) {
  const detail = String(error?.message || "").trim();
  if (!detail || detail === ERROR_MESSAGES.server) return ERROR_MESSAGES.server;
  const sentence = detail.replace(/[.\s]+$/, "");
  return /try again/i.test(sentence)
    ? `Server error: ${sentence}.`
    : `Server error: ${sentence}. Please try again later.`;
}
